class OrigoElement extends HTMLElement {
  getRoute() {
    return this.route || Shopify?.routes?.root?.slice(0, -1) || '';
  }

  getQuestion(id) {
    id = id || this.getQuestionEle().dataset.id;
    this.question = window.origoProfile?.questions.find(q => q.id === id);
    return this.question;
  }

  getQuestionEle() {
    this.questionEle = this.questionEle || this.closest('origo-question');
    return this.questionEle;
  }
  getQuestionElements(){
    this.questionElements = this.questionElements || [...document.querySelectorAll('origo-question'), ...document.querySelectorAll('original-product')];
    return this.questionElements;
  }
  /**
   * Return a Map mapping question IDs to their corresponding DOM elements.
   * The Map is lazily constructed and cached for subsequent calls to avoid
   * repeated DOM queries while keeping the implementation unsurprising.
   */
  getQuestionElementsMap(){
    if(!this.questionElementsMap){
      this.questionElementsMap = new Map(this.getQuestionElements().map(q => [q.dataset.id, q]));
    }
    return this.questionElementsMap;
  }
  /**
   * Fetch a single `origo-question` element by its `dataset.id`.
   * This uses the cached Map for O(1) look-ups.
   */
  getQuestionElementById(id){
    return this.getQuestionElementsMap().get(id);
  }
  scrollToQuestion(questionId) {
    document.querySelector(`section:has(#${questionId})`).scrollIntoView({behavior: 'instant', block: 'center', inline: "end"});
  }
  getOrigoVersion(){
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    this.origoVersion = searchParams.get('view') || 'origo';
    return this.origoVersion;
  }
  gtag(){window.dataLayer.push(arguments);}
  trackEvent(tracking){
    if (!tracking) return;
    const { name, label, value } = tracking;
    // Google Analytics Tracking
    if (window.dataLayer) {
      this.gtag('event', name, {
        event_category: 'engagement', // Adjust as needed
        event_label: label,
        value: value,
        transport_type: 'beacon'
      });
    }
    // Facebook Pixel Tracking
    if (window.fbq) {
      window.fbq('trackCustom', name, {
        content_name: label,
        value: value
      });
    }
    // Klavio Tracking pk_05e45232b1117e5de7ee21c28208ce0fa5
    if (window.klaviyo) {
      window.klaviyo.push(['track', name, {
        answer: label,
        value: value
      }]);
    }
  }
  navigatePage(href, tracking){
    if (tracking) {
      this.trackEvent(tracking);
    }
    window.location.href = href;
  }

  setActiveQuestion(questionId) {
    let questionElement;
    this.getQuestionElements().forEach((questionEle, index) => {
      // 1. if the question was answered, set it as "viewed" = "true"
      questionEle.dataset.viewed = this.getQuestion(questionEle.dataset.id)?.answered === 'true' ? 'true' : 'false';
      // 2. the first unanswered question becomes the active one
      if (!questionElement && !window.origoProfile.session.answeredQuestions.includes(questionEle.dataset.id)){
        questionElement = questionEle;
        questionEle.dataset.active = 'true';
        document.getElementById('origo-page-number').innerText = (index + 1).toString();
      }
      // 3. if there is no unanswered question and questionId == question.id set it as active
      else if (!questionElement && questionEle.id === questionId){
        questionElement = questionEle;
        questionEle.dataset.active = 'true';
        document.getElementById('origo-page-number').innerText = (index + 1).toString();
      } else {
        questionEle.dataset.active = 'false';
      }
    });
    // 4. after the for-loop, if no question is active, set the first unanswered question
    if (!questionElement){
      for (const [index, questionEle] of this.getQuestionElements().entries()) {
        if (!window.origoProfile.session.answeredQuestions.includes(questionEle.dataset.id)){
          questionElement = questionEle;
          questionEle.dataset.active = 'true';
          document.getElementById('origo-page-number').innerText = (index + 1).toString();
          break;
        }
      }
    }
    // 5. if still no questionElement, then set the last questionEle as active
    if (!questionElement){
      questionElement = this.getQuestionElements()[this.getQuestionElements().length - 1];
      questionElement.dataset.active = 'true';
      document.getElementById('origo-page-number').innerText = (this.getQuestionElements().length).toString();
    }
    window.origoProfile.session.activeQuestionId = questionElement.dataset.id;
    this.setActiveSection(questionElement);
  }
  setActiveSection(questionElement){
    if (!window.origoProfile.session.sectionsMap){ return; }
    document.querySelectorAll('.origo-section').forEach(sectionEle => {
      sectionEle.dataset.active = (sectionEle.dataset.id === questionElement.dataset.sectionId)?.toString();
      const questionIds = window.origoProfile.session.sectionsMap.get(sectionEle.dataset.id);
      if (questionIds){
        let allAnswered = true;
        for (const questionId of questionIds){
          if (!window.origoProfile.session.answeredQuestions.includes(questionId)){
            allAnswered = false;
            break
          }
        }
        sectionEle.dataset.answered = allAnswered ? 'true' : 'false';
      }
    });
  }
  setOrigoAnsweredQuestions(questionId, answered = true){
    const questionEle = document.querySelector(`origo-question#${questionId}`);
    if (questionEle && ['SINGEL','MULTI'].indexOf(questionEle.dataset.type) >= 0) {
      questionEle.dataset.answered = 'false';
      for (const answerEle of questionEle.querySelectorAll('origo-answer')){
        if (answerEle.dataset.selected === 'true') {
          questionEle.dataset.answered = 'true';
          break;
        }
      }
    }
    if (questionEle.dataset.type === 'INPUT' && !this.hasEmptyRequiredInput(questionEle)
      || questionEle.dataset.type === 'COLORS'){
      questionEle.dataset.answered = 'true';
    }
    if (questionEle?.dataset.answered === 'true') {
      // Check if the question is not already in the answeredQuestions
      if (!window.origoProfile.session.answeredQuestions.includes(questionId)) {
        window.origoProfile.session.answeredQuestions.push(questionId);
      }
      // If the type is 'MULTI', ensure it stays in answeredQuestions
      // No action needed here since it's already added above
    } else if (questionEle?.dataset.answered === 'false') {
      // Remove the questionId if it is in answeredQuestions
      const index = window.origoProfile.session.answeredQuestions.indexOf(questionId);
      if (index > -1) {
        window.origoProfile.session.answeredQuestions.splice(index, 1);
      }
    }
    this.setForwardBackwardButtons();
  }
  /** ADDON: pass the questionId as a parameter, if present navigate there,
   * ADDON: warn if an answer links to a question that is before the current one
  */
  navigateToOrigoQuestion(direction) {
    const backNav = direction === 'back';
    const questionId = window.origoProfile.session.activeQuestionId;

    // Logic where to navigate if it is a last question (works for INPUT & SINGLE answers)
    if (!backNav && this.isLastQuestion(questionId)){

      // restoring the session will navigate to this url
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      const viewParam = params.get('view');
      const filteredSearch = viewParam ? `?view=${encodeURIComponent(viewParam)}` : '';
      window.origoProfile.session.lastMatch.url = url.pathname.slice(this.getRoute().length) + filteredSearch;
      this.storeOrigoProfile();
      window.updateOrigoProfile().then(r => {
        this.saveOrigoToCustomer().then(() => {
          const product = window.origoProfile.session.products[window.origoProfile.session.lastProduct];
          const compareWith = `compare_with=${product?.matchedVariants.slice(-1)[0]?.handle}&compare_with_variant=${product?.matchedVariants.slice(-1)[0]?.id}`;
          this.navigatePage(
              this.getRoute() + product?.matchedVariants.slice(-1)[0]?.url,
              {
                name: `${this.getOrigoVersion()}_finished`,
                label: `${this.getOrigoVersion()} Finished Button`,
                value: 1
              }
          );
        });
      })
      return;
    }

    for (const [index, questionEle] of this.getQuestionElements().entries()) {
      if (questionEle.id === questionId && (index + 1) < this.getQuestionElements().length + 1) {
        const targetQuestionEle = backNav ? this.getQuestionElements()[index - 1] : this.getQuestionElements()[index + 1];
        if (targetQuestionEle) {
          this.setActiveQuestion(targetQuestionEle.id);
          this.scrollToQuestion(window.origoProfile.session.activeQuestionId);
        }
        break;
      }
    }
    this.setForwardBackwardButtons();
    this.storeOrigoProfile();
    this.updateOrigoProfile().then();
    this.getMatch().then( );
  }

  setForwardBackwardButtons(){
    let previousQuestionEle;
    let nextQuestionEle;
    for (const [index, questionEle] of this.getQuestionElements().entries()) {
      if (questionEle.id === window.origoProfile.session.activeQuestionId && (index + 1) < this.getQuestionElements().length + 1) {
        previousQuestionEle = this.getQuestionElements()[index - 1];
        nextQuestionEle = questionEle;
        break
      }
    }
    // Logic to set forward button for all questions except the last
    const forwardButton = document.getElementById('origo-forward');
    forwardButton.disabled =
      ['SINGEL','MULTI'].indexOf(nextQuestionEle.dataset.type) >= 0 && !window.origoProfile.session.answeredQuestions.includes(nextQuestionEle.id)
      || ['COLOR', 'INPUT'].indexOf(nextQuestionEle.dataset.type) >=0 && this.hasEmptyRequiredInput(nextQuestionEle);
    // Logic to set forward button for the last question
    const navigationEle = document.getElementById('origo-forward-backward');
    if (forwardButton.disabled !== true && this.isLastQuestion(nextQuestionEle.id)){
      forwardButton.disabled = false;
      navigationEle.classList.add('origo-last-question');
    } else {
      navigationEle.classList.remove('origo-last-question');
    }
    // Logic to set back button for all questions
    document.getElementById('origo-back').disabled = !previousQuestionEle;
  }

  isLastQuestion(questionId) {
    return [...this.getQuestionElements()].findIndex(qE => qE.id === questionId) === this.getQuestionElements().length - 1
  }

  hasEmptyRequiredInput(questionEle) {
    for (const inputEle of questionEle.querySelectorAll('input, select')) {
      if (inputEle.hasAttribute('required') && inputEle.value === ''
        || !inputEle.checkValidity()) {
        return true;
      }
    }
    questionEle.dataset.answered = 'true';
    return false;
  }

  async updateOrigoProfile() {
    const stringOrigoProfile = JSON.stringify(window.origoProfile);
    this.storeOrigoProfile(stringOrigoProfile);
    const response = await fetch('https://oplus.cognify.ai/api/ai/v6/update', {
      method: 'POST',
      headers: {
        'Authorization': 'Basic b3BsdXM6ejJSbkZwaDVzd0RIZUU4S3JXYWhHZ0t6',
        'Content-Type': 'application/json'
      },
      body: stringOrigoProfile
    })
    if (response.ok) {
      // ensure the response is a valid profile
      const parsedResponse = response.toString().indexOf('sessionId') > -1 ? JSON.parse(response) : null;
      if (parsedResponse?.sessionId?.length > 0) {
        window.origoProfile = response.json();
      }
    }
  }

  async getMatch(){
    const stringOrigoProfile = JSON.stringify(window.origoProfile);
    try {
      const response = await fetch(`https://oplus.cognify.ai/api/ai/v6/match`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: stringOrigoProfile
      });
      if (response.ok){
        const data = await response.json();
        if (data){
          if (data.matches[1]) {
            this.fetchProduct(data.matches[1]).then()
          } else if (data.matches[0]) {
            this.fetchProduct(data.matches[0]).then()
          }
          if (!window.origoProfile.session.lastMatch) { window.origoProfile.session.lastMatch = {}; }
          window.origoProfile.session.lastMatch["binding"] = data?.bindingNumber,
          window.origoProfile.session.lastMatch["finish"] = data?.finish,
          window.origoProfile.session.lastMatch["tuning"] = data?.tuning,
          window.origoProfile.session.lastMatch["keilcode"] = data?.code,
          window.origoProfile.session.lastMatch["length"] = data?.length,
          window.origoProfile.session.lastMatch["matches"] = data?.matches
          if (data.mod){
            window.origoProfile.session.colors.mod = data.mod.split('.')[1].toUpperCase();
          }
        }
      } else {
        console.log("not yet");
      }
    } catch (error) {}
  }
  async fetchProduct(sku){
    sku = sku ||"S0006.IG.175.B"
        // 2026-09-07: Shopify predictive search no longer resolves the "variants.sku:" prefix.
    const hit = await fetch(`/search/suggest.json?q=${encodeURIComponent(sku)}&resources[type]=product&resources[options][fields]=variants.sku&limit=1`)
      .then(response => response.json())
      .then(response => response.resources.results.products[0]);
    let variant = hit?.variants?.[0];
    if (!variant && hit?.handle) {
      const pj = await fetch(`/products/${hit.handle}.js`).then(response => response.json());
      const v = pj.variants.find(v => v.sku === sku);
      if (v) variant = { id: v.id, title: v.title, sku: v.sku, available: v.available, url: `/products/${hit.handle}?variant=${v.id}` };
    }
    if (!variant) { console.error('ORIGO: no variant found for', sku); return; }
    const response = await fetch(`${variant.url}&view=json`).then(response => response.json());
    const product = response.product;
    product.matchedVariants = product.matchedVariants || [];
    product.matchedVariants.push(variant);
    window.origoProfile.session.products = window.origoProfile.session.products || {};
    window.origoProfile.session.lastProduct = sku;
    window.origoProfile.session.products[sku] = product;
    window.origoProfile.session.lastMatch.title = product.title;
    window.origoProfile.session.lastMatch.date = new Date().toISOString();
    window.origoProfile.session.lastMatch.productUrl = variant.url;


    if (['8T', '9T'].indexOf(window.origoProfile.session.colors.mod) > -1){
      document.querySelector('origo-colors[data-id="ski-logoType"] label:has([value="PATTERN"])')?.style.setProperty('display', 'block');
    } else {
      document.querySelector('origo-colors[data-id="ski-logoType"] label:has([value="PATTERN"])')?.style.setProperty('display', 'none');
    }
  }

  storeOrigoProfile(stringOrigoProfile) {
    localStorage.setItem('origoProfile', stringOrigoProfile
      || JSON.stringify(window.origoProfile)
      || localStorage.getItem('origoProfile')
      || '{}');
  }

  async saveOrigoToCustomer() {
    let allOrigoProfiles = await this.getCustomerUpdate(this.dataset.customerEmail) || {};

    allOrigoProfiles[window.origoProfile.sessionId] = {
      "responses": window.origoProfile.session.responses,
      "match": window.origoProfile.session.lastMatch
    };


    let origoProfilesString = "";
    let isFirst = true;
    for (const [id, origoProfile] of Object.entries(allOrigoProfiles)) {
      if (!isFirst) {
        origoProfilesString += ",\\n\\n";
      } else { isFirst = false;}
      origoProfilesString += '"' + id + '":' + JSON.stringify(origoProfile);
    }
    origoProfilesString = "{" + origoProfilesString + "}"
    this.updateOrigoToCustomer(origoProfilesString).then();
  }
  async updateOrigoToCustomer(origoProfilesString) {

    const metafields = {
      "customerId": `gid://shopify/Customer/${window.origoProfile.session.customerId}`,
      "namespace": "custom",
      "key": "origo",
      "value": origoProfilesString.replace(/,/g, ',\\n').replace(/"/g, '\\\"'),
      "type": "multi_line_text_field"
    }
    await fetch(`https://oplus.cognify.ai/api/customer/update`, {
      method: 'POST',
      headers: {
        'Authorization': 'Basic b3BsdXM6ejJSbkZwaDVzd0RIZUU4S3JXYWhHZ0t6',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(metafields)
    });
  }

  async getCustomerUpdate(email) {
    let origoValue = null;
    try {
      const response = await fetch(`https://oplus.cognify.ai/api/customer/get?email=${email}`);
      let responseJson;
      try {
        responseJson = await response.json();
      } catch (jsonError) {
        return window.oldSessions = {};
      }
      const customersEdges = responseJson?.data?.customers?.edges;
      if (customersEdges && customersEdges.length > 0) {
        for (const edge of customersEdges) {
          const metafieldsEdges = edge.node.metafields.edges;
          for (const metafieldEdge of metafieldsEdges) {
            const node = metafieldEdge.node;
            if (node.key === "origo") {
              origoValue = node.value;
              break;
            }
          }
          if (origoValue !== null) break;
        }
      }
    } catch (error) {
      return window.oldSessions = {};
    }

    let jsonProfile;
    if (origoValue) {
      try {
        jsonProfile = JSON.parse(origoValue);
      } catch (error) {
        jsonProfile = JSON.parse(origoValue.replace(/\\\"/g, '"').replace(/\\\\/g, '\\'));
      }
      window.oldSessions = jsonProfile || {};
      return jsonProfile || {};
    }
  }
}

class OrigoSection extends OrigoElement {
  constructor(){
    super();
    this.addEventListener('click', this.sectionClickHandler);
  }

  sectionClickHandler(){
    const questionIds = window.origoProfile.session.sectionsMap.get(this.dataset.id);
    if (questionIds){
      for (const questionId of questionIds){
        if (document.getElementById(questionId).dataset.answered !== 'true'){
          this.setActiveQuestion(questionId);
          this.scrollToQuestion(window.origoProfile.session.activeQuestionId);
          return;
        }
      }
      this.setActiveQuestion(questionIds[0]);
      this.scrollToQuestion(window.origoProfile.session.activeQuestionId);
    }
  }
}
customElements.define('origo-section', OrigoSection);

class OrigoSections extends OrigoElement {
  questions;
  constructor(){
    super();
    document.addEventListener('DOMContentLoaded', () => {
      this.getProfile().then();
    });
    document.querySelector('#origo-forward').addEventListener('click', () => {
      this.navigateToOrigoQuestion();
    });
    document.querySelector('#origo-back').addEventListener('click', () => {
      this.navigateToOrigoQuestion('back');
    });
    this.querySelector('#origo-close-button a').addEventListener('click', (event) =>{
      event.preventDefault();
      localStorage.removeItem('origoProfile');
      this.navigatePage(window.location.origin + this.getRoute());
    });
    if(Shopify.designMode === true){
      const realPreview = document.querySelector('#realPreview');
      if (realPreview) {
        realPreview.addEventListener('click', (event) => this.realPreview(event));
      }
    }
  }
  hasAnsweredQuestionParams = false;


  async getProfile(){
    const params = new URLSearchParams(window.location.search);
    let sessionId = params?.get('sessionId') ? `?sessionId=${params.get('sessionId')}` : '';
    window.origoProfile = window.origoProfile || JSON.parse(localStorage.getItem('origoProfile')) || null;
    for (const [qId, answerId] of params.entries()) {
      // only treat known question-keys
      const questionEle = this.getQuestionElementById(qId);
      if (questionEle) {
        const answerEle = questionEle.querySelector(`[data-id="${answerId}"]`);
        if (!!answerEle) {
          localStorage.removeItem('origoProfile');
            sessionId = '';
            this.hasAnsweredQuestionParams = true;
            break
        }
      }
    }
    if (!window.origoProfile || !window.origoProfile.sessionId || window.origoProfile.sessionId !== sessionId){
      window.origoProfile = null;
      window.origoProfile = await fetch(`https://oplus.cognify.ai/api/profile/v6/get${sessionId}`)
        .then(response => response.json());
    }
    if (window.origoProfile){
      this.initializeConfigurator();
      document.dispatchEvent(new Event('profileLoaded'));
    }
  }
  setOrigoProfile(profile) {
    window.origoProfile = profile;
    this.sectionsMap = new Map();
    this.session = window.origoProfile.session = window.origoProfile.session || {};
    window.origoProfile.session.colors = window.origoProfile.session.colors ||{};
    window.origoProfile.session.answeredQuestions = window.origoProfile.session.answeredQuestions || [];
    window.origoProfile.session.responses = window.origoProfile.session.responses || {};
    window.origoProfile.session.customerId = this.dataset.customerId;
    window.origoProfile.session.sectionsMap = this.sectionsMap;
  }
    
  initializeConfigurator() {
    this.setOrigoProfile(window.origoProfile);
    const newUrl = new URL(window.location.href);

    let activeQuestionId =  null;
    if (newUrl.searchParams.get('continue') === null) {
      activeQuestionId = this.getQuestionElements()[0].id;
    } else {
      history.replaceState(null, '', newUrl.toString());
    }
    // set questions and answers from url params
    if (this.hasAnsweredQuestionParams){
      const params = newUrl.searchParams;
      for (const [qId, answerId] of params.entries()) {
        // only treat known question-keys
        const questionEle = this.getQuestionElementById(qId);
        if (questionEle) {
          const answerEle = questionEle.querySelector(`[data-id="${answerId}"]`);
          if (answerEle) {
            answerEle.dataset.selected = 'true';
            window.origoProfile.session.responses[qId] = [answerId];
            questionEle.dataset.answered = 'true';
          }
          if (!window.origoProfile.session.answeredQuestions.includes(qId)) {
            window.origoProfile.session.answeredQuestions.push(qId);
          }
          const answer = this.getQuestion(qId)?.needs?.find(answer => answer.id === answerId);
          if (answer) {
            answer.selected = true;
          }
          
        }
      }
    }

    this.setActiveQuestion(activeQuestionId);
    this.setForwardBackwardButtons();

    this.getQuestionElements().forEach(questionEle => {
      this.querySelectorAll('.origo-section').forEach(section => {
        if (section.dataset.id === questionEle.dataset.sectionId) {
          if (this.sectionsMap.has(section.dataset.id)) {
            this.sectionsMap.get(section.dataset.id).push(questionEle.dataset.id);
          } else {
            this.sectionsMap.set(section.dataset.id, [questionEle.id]);
          }
        }
      });
      if (window.origoProfile.session.answeredQuestions.length > 0) {
        questionEle.dataset.answered = (window.origoProfile.session.answeredQuestions.includes(questionEle.id) > -1).toString();
      }
      questionEle.querySelectorAll('origo-answer').forEach(answerEle => {
        if (window.origoProfile.session.responses[questionEle.id]) {
          answerEle.dataset.selected = (window.origoProfile.session.responses[questionEle.id].indexOf(answerEle.dataset.id) >= 0).toString();
        }
      });
      questionEle.querySelectorAll('origo-input').forEach(inputEle => {
        if (window.origoProfile.session.responses[inputEle.dataset.id]) {
          let value = window.origoProfile.session.responses[inputEle.dataset.id];
          if(inputEle.querySelector('input').type === 'date'){ value = new Date(value).toISOString().split('T')[0]; }
          inputEle.querySelector('input').value = value;
        }
      });
      questionEle.querySelectorAll('origo-dropdown').forEach(dropdownEle => {
        const dropdownValue = window.origoProfile.session.responses[dropdownEle.dataset.id];
        if (dropdownValue) {
          dropdownEle.querySelector('select').value = dropdownValue.toString();
          dropdownEle.querySelector(`option[value="${dropdownValue.toString()}"]`)?.setAttribute('checked', 'true');
        }
      });
      questionEle.querySelectorAll('origo-radio').forEach(radioEle => {
        const storedValue = window.origoProfile.session.responses[questionEle.dataset.id];
        if (storedValue) {
          radioEle.querySelectorAll('input[type="radio"]').forEach(input => {
            input.checked = input.value.toLowerCase() === storedValue.toLowerCase();
          });
        }
      });
    });

    this.storeOrigoProfile();
    this.scrollToQuestion(window.origoProfile.session.activeQuestionId);

    document.getElementById('origo-total-pages').innerText = this.getQuestionElements().length.toString();

    setTimeout(() => {window.setSVG(true).then()}, 150);
  }
}
customElements.define('origo-sections', OrigoSections);

class OrigoQuestion extends OrigoElement {
  constructor(){
    super();
    if (window.origoProfile){
      this.initializeOrigoQuestions();
    } else {
      document.addEventListener('profileLoaded', () => {
        this.initializeOrigoQuestions();
      });
    }
  }
  initializeOrigoQuestions() {
    this.setOrigoAnsweredQuestions(this.id, !this.hasEmptyRequiredInput(this));
 /*   if (this.dataset.type === 'COLORS'){
      if (window.origoProfile?.session?.colors?.ski?.length > 0) {
        this.querySelectorAll('origo-colors').forEach(colorEle => {
          const storedColor = window.origoProfile.session.responses[colorEle.dataset.id.replace(/^ski-/, '')] || window.origoProfile.session.colors[colorEle.dataset.id.replace(/^ski-/, '')];
          colorEle.querySelectorAll('input[type="radio"]').forEach(input => {
            input.checked = input.value.toLowerCase().indexOf(storedColor.toLowerCase()) > -1;
          });
        });
      }
      else {
        this.querySelectorAll('origo-colors').forEach(colorEle => {
          const firstInput = colorEle.querySelectorAll('input[type="radio"]')[0];
          if (firstInput) {
            firstInput.checked = true;
          }
        });
      }
      this.getMatch().then(() => {
          setTimeout(() => {
            window.setSVG(true)
          }, 50);
        }
      );
    } else */
    if (this.dataset.type === 'INPUT' && this.dataset.unitDefault?.length > 0 && this.dataset.unitAlternative?.length > 0) {
      this.querySelectorAll('[class*="o-unit-options-"]').forEach(unitEle => {
        unitEle.addEventListener('click', (event) => {
          const unitsElement = unitEle.closest('.o-unit-options');
          const selectedUnit = event.currentTarget.dataset.unit;
          if (unitsElement.dataset.activeUnit === selectedUnit) return;
          const isDefaultUnit = selectedUnit === '1';

          this.querySelectorAll('origo-input').forEach(origoInputEle => {
            const input = origoInputEle.querySelector('input');
            const labelEle = origoInputEle.querySelector('.o-unit-option-active');
            if (!input || !labelEle) return;
            const currentValue = parseFloat(input.value);
            const conversionFactor = parseFloat(input.dataset.conversion);
            // Convert min and max attributes
            const min = parseFloat(input.min);
            const max = parseFloat(input.max);
            if (!isNaN(min)) {
              const convertedMin = isDefaultUnit ? min / conversionFactor : min * conversionFactor;
              input.min = convertedMin.toFixed(0);
            }
            if (!isNaN(max)) {
              const convertedMax = isDefaultUnit ? max / conversionFactor : max * conversionFactor;
              input.max = convertedMax.toFixed(0);
            }
            if (!isNaN(currentValue)) {
              const convertedValue = isDefaultUnit ? currentValue / conversionFactor : currentValue * conversionFactor;
              input.value = convertedValue.toFixed(0);
            }
            labelEle.textContent = `(${isDefaultUnit ? labelEle.dataset.defaultUnit : labelEle.dataset.alternativeUnit})`;
            input.placeholder = isDefaultUnit ? labelEle.dataset.defaultUnit : labelEle.dataset.alternativeUnit;
          });

          unitsElement.dataset.activeUnit = selectedUnit;
        });
      });
    }
  }
}
customElements.define('origo-question', OrigoQuestion);

class OrigoAnswer extends OrigoElement {
  constructor() {
    super();
    this.addEventListener('click', this.answerClickHandler.bind(this));
  }

  answerClickHandler() {
    const responseQuestion = window.origoProfile.session.responses[this.getQuestionEle().id] = [];
    this.getAnswerElements().forEach(answerEle => {
      if (this.getQuestionEle().dataset.type === 'SINGEL') {
        answerEle.dataset.selected = (answerEle.dataset.id === this.dataset.id).toString();
      } else if (this.getQuestionEle().dataset.type === 'MULTI') {
        if (answerEle.dataset.id === this.dataset.id) {
          answerEle.dataset.selected = answerEle.dataset.selected === 'true' ? 'false' : 'true';
        }
      } else { // INPUT && COLORS
        answerEle.dataset.selected = (answerEle.dataset.selected === 'true').toString();
      }
      if (answerEle.dataset.selected === 'true') {
        responseQuestion.push(answerEle.dataset.id);
        this.trackEvent(
          {
            name: `${this.getOrigoVersion()}_${this.getQuestionEle().id}`,
            label: `${this.getOrigoVersion()} ${this.getQuestionEle().id}`,
            value: answerEle.dataset.id
          }
        )
      }
      const answer = this.getQuestion()?.needs?.find(answer => answer.id === answerEle.dataset.id);
      if (answer) {
        answer.selected = answerEle.dataset.selected === 'true';
      }
    });
    if (['SINGEL', 'MULTI'].includes(this.getQuestionEle().dataset.type)) {
      this.setOrigoAnsweredQuestions(this.getQuestionEle().id);
    }
    if (this.dataset.url) {
      this.storeOrigoProfile();
      let url;
      try {
        url = new URL(this.dataset.url);
      } catch {
        url = new URL(this.dataset.url, window.location.href);
      }
      if (this.getRoute().length > 1) {
        if (this.dataset.url.indexOf(this.getRoute()) < 0) {
          url.pathname = this.getRoute() + url.pathname.toString();
        }
      }
      this.navigatePage(url.toString());
      return;
    }
    if (this.getQuestionEle().dataset.type === 'SINGEL') {
      this.navigateToOrigoQuestion();
    }
  }

  getAnswerElements() {
    this.answerElements = this.answerElements || this.getQuestionEle().querySelectorAll('origo-answer');
    return this.answerElements;
  }

}

customElements.define('origo-answer', OrigoAnswer);

class OrigoInput extends OrigoElement {
  constructor() {
    super();
    this.inputEle = this.querySelector('input') || this.querySelector('select') || this.querySelector('textarea');
    if (this.inputEle?.type === 'text' || this.inputEle?.type === 'number' || this.inputEle?.nodeName === 'TEXTAREA') {
      this.eventType = 'keyup';
      this.addEventListener('keyup', this.inputBlur.bind(this));
    } else {
      this.addEventListener('change', this.inputBlur.bind(this));
    }
  }

  inputBlur() {
    const debounceTime = this.eventType === 'keyup' ? 500 : 0;
    let timeout
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      // const responseQuestion = window.origoProfile.session.responses[this.getQuestionEle().id] = [];
      this.getInputElements().forEach(inputEle => {

        let value = inputEle.querySelector(':checked')?.value
          || inputEle.querySelector('input')?.value

        const date = inputEle.querySelector('[type="date"]')
        if (date){
          value = new Date(date.value)?.getTime() || '';
        }

        if (value) {
          let storedValue = value;
          const unitsEle = this.querySelector('.o-unit-options');
          if (unitsEle){
            const isDefaultUnit = unitsEle.dataset.activeUnit === '1';
            const conversionFactor = parseFloat(this.dataset.conversion);
            storedValue = isDefaultUnit ? value : value / conversionFactor;
          }
          window.origoProfile.session.responses[inputEle.dataset.id] = storedValue;
          this.trackEvent(
            {
              name: `${this.getOrigoVersion()}_${inputEle.dataset.id}`,
              label: `${this.getOrigoVersion()} ${inputEle.dataset.id}`,
              value: storedValue
            }
          )
        }

        // responseQuestion.push({id: inputEle.dataset.id, value: value});
        if (inputEle.dataset.id === 'ski_text') {
          this.setSkiName(value)
        }

        if (!window.origoProfile || !window.origoProfile.questions) return;
        // Find the question with the matching id
        const question = window.origoProfile.questions.find(q => q.id === inputEle.dataset.id);
        // If the question is found and it has needs
        if (question && question.needs && question.needs.length > 0) {
          for (const need of question.needs) {
            const ele = inputEle.querySelector(`[data-id="${need.id}"]`);
            need.selected = ele.checked || ele.selected;
            if (ele.tagName !== 'OPTION') {
              need.value = value;
              need.selected = !!need.value;
            }
          }
        }
      });
      this.setOrigoAnsweredQuestions(this.getQuestionEle().id, !this.hasEmptyRequiredInput(this.getQuestionEle()));
    }, debounceTime);
  }
  setSkiName(value) {
    if(this.getQuestionEle().dataset.viewProduct !== 'true' || !window.origoProfile.session.colors) { return; }
    window.origoProfile.session.colors.text = value;
    window.setSVG().then();
  }

  getInputElements() {
    this.colorElements = this.answerElements || this.getQuestionEle().querySelectorAll('origo-colors');
    this.inElements = this.inElements || this.getQuestionEle().querySelectorAll('origo-input');
    this.radioElements = this.radioElements || this.getQuestionEle().querySelectorAll('origo-radio');
    this.dropElements = this.dropElements || this.getQuestionEle().querySelectorAll('origo-dropdown');
    this.inputElements = this.inputElements || [...this.colorElements, ...this.inElements, ...this.dropElements, ...this.radioElements];
    return this.inputElements;
  }
}

customElements.define('origo-input', OrigoInput);

class OrigoRadio extends OrigoInput {}
customElements.define('origo-radio', OrigoRadio);

class OrigoDropdown extends OrigoInput {}
customElements.define('origo-dropdown', OrigoDropdown);
